import React from 'react';

const HoverText = ({ children, className = '', style = {}, as = 'div' }) => {
  const Component = as;
  
  return (
    <Component
      className={`hover-text-simple ${className}`}
      style={{
        fontSize: '42px',
        fontWeight: 700,
        color: '#222',
        lineHeight: 1.3,
        cursor: 'default',
        textAlign: 'left',
        verticalAlign: 'baseline',
        marginTop: 0,
        marginBottom: '16px',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        transition: 'color 0.3s ease, transform 0.3s ease',
        ...style
      }}
    >
      {children}
    </Component>
  );
};

export default HoverText;
